/**
 * 语言路由布局：/:lang/*
 * - 校验 lang ∈ zh|en
 * - 同步 i18n.changeLanguage + localStorage allinks_chd_lang
 */
import { useEffect } from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import i18n from '@/i18n';
import { CHD_LANG_STORAGE_KEY } from '@/i18n/resources';
import { getPreferredLang, isChdLang, localePath, stripLangPrefix } from '@/i18n/localePath';

export default function LocaleLayout() {
  const { lang } = useParams<{ lang: string }>();
  const location = useLocation();

  const resolved = isChdLang(lang) ? lang : null;

  useEffect(() => {
    if (!resolved) {
      return;
    }
    localStorage.setItem(CHD_LANG_STORAGE_KEY, resolved);
    if (i18n.language !== resolved) {
      void i18n.changeLanguage(resolved);
    }
  }, [resolved]);

  if (!resolved) {
    // /:lang 命中了非法段（如 /fr/...）→ 偏好语言 + 剥离后的业务路径
    const bare = stripLangPrefix(location.pathname);
    return (
      <Navigate
        to={`${localePath(bare, getPreferredLang())}${location.search}${location.hash}`}
        replace={true}
      />
    );
  }

  return <Outlet />;
}
